// removed by extract-text-webpack-plugin
module.exports = {"ColorIcon":"ColorIcon__ColorIcon___DkJbe","ColorIconInside":"ColorIcon__ColorIconInside___30jzI","ColorIconActive":"ColorIcon__ColorIconActive___3_9-t"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Icons/ColorIcon/ColorIcon.less
// module id = 1332
// module chunks = 0 1